<template>
  <div class="uk-section ba-secondary-section">

    <div class="uk-container">

      <div class="uk-text-center uk-margin-large-bottom">
        <h2 class="uk-h2 uk-margin-remove-bottom">Quick and Easy VM Provisioning</h2>
        <h4 class="uk-h4 uk-margin-small-top">Simplicity and flexibility are at the heart of all of our products. Deploy a virtual machine painlessly in 3 simple steps.</h4>
      </div>

      <div class="uk-grid-match uk-grid-collapse uk-flex uk-flex-center" uk-grid>

        <div class="uk-width-1-4@m uk-width-1-1@s">
          <div class="uk-card uk-text-center">
            <div class="uk-card-body">
              <span uk-icon="icon: sign-in; ratio: 2.5"></span>
              <h4 class="uk-h4 uk-margin-small-top">Sign Up</h4>
              <p class="uk-text-center">Enter your personal information and add a billing account</p>
            </div>
          </div>
        </div>

        <div class="uk-width-auto uk-visible@m">
          <div class="uk-flex ba-center-chevron">
            <span uk-icon="icon: chevron-right; ratio: 2.5"></span>
          </div>
        </div>

        <div class="uk-width-1-1 uk-hidden@m">
          <div class="uk-flex uk-flex-center">
            <span uk-icon="icon: chevron-down; ratio: 2.5"></span>
          </div>
        </div>

        <div class="uk-width-1-4@m uk-width-1-1@s">
          <div class="uk-card uk-text-center">
            <div class="uk-card-body">
              <span uk-icon="icon: settings; ratio: 2.5"></span>
              <h4 class="uk-h4 uk-margin-small-top">Configure</h4>
              <p class="uk-text-center">Configure your virtual machine by selecting your OS and resources</p>
            </div>
          </div>
        </div>

        <div class="uk-width-auto uk-visible@m">
          <div class="uk-flex ba-center-chevron">
            <span uk-icon="icon: chevron-right; ratio: 2.5"></span>
          </div>
        </div>

        <div class="uk-width-1-1 uk-hidden@m">
          <div class="uk-flex uk-flex-center">
            <span uk-icon="icon: chevron-down; ratio: 2.5"></span>
          </div>
        </div>

        <div class="uk-width-1-4@m uk-width-1-1@s">
          <div class="uk-card uk-text-center">
            <div class="uk-card-body">
              <span uk-icon="icon: server; ratio: 2.5"></span>
              <h4 class="uk-h4 uk-margin-small-top">Deploy</h4>
              <p class="uk-text-center">Then click Deploy! Your virtual machine will be immediately available in the portal</p>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {
	name: 'provisioning'
}
</script>

<style scoped lang="less">
.ba-center-chevron {
  justify-content: center;
  align-items: center;
}
.uk-card {
  background-color: #1b1b1b;
}
.uk-icon {
  color: rgba(194, 151, 50, 1); //ba-gold
}
.uk-h4 {
  color: #fff;
}
</style>
